import { render } from "./CityEditComponent.vue?vue&type=template&id=1db3935d"
import script from "./CityEditComponent.vue?vue&type=script&lang=js"
export * from "./CityEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__